import client from "./sharedoClient";

const get = () => client.get("api/wordaddin/contentBlockTypes");

export default {
    get
}